export default function GatewaysSkeleton() {
    return (
        <div className='animate-pulse rounded-xl bg-gray-100 p-4'>
            <div className='mb-4 h-4 w-40 rounded bg-gray-300' />
            <div>
                <div className='flex items-start gap-3 rounded-lg p-3'>
                    <div className='h-5 w-5 rounded-full border border-gray-300 bg-gray-200' />
                    <div className='flex-1 space-y-2'>
                        <div className='h-4 w-16 rounded bg-gray-300' />
                        <div className='h-3 w-20 rounded bg-gray-200' />
                    </div>
                </div>
                <div className='flex items-start gap-3 rounded-lg px-3 pt-3'>
                    <div className='h-5 w-5 rounded-full border border-gray-300 bg-gray-200' />
                    <div className='flex-1 space-y-2'>
                        <div className='h-4 w-20 rounded bg-gray-300' />
                        <div className='flex items-center gap-1'>
                            <div className='h-3 w-16 rounded bg-gray-200' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

